import { WIDTH, } from './types'

export function globalWidth(text) {
  return (dispatch) => {
    dispatch({
      type: WIDTH,
      payload: text,
    })
  }
}